module.exports = __webpack_public_path__ + "img/16.4caf75a4.jpg";